import { Col, Row, message } from "antd";
import TableGroupDepartures from "./table";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { pdfDepartureListByClientDateEvent } from "../../../../../_events/order_list_view/find.event";
import { Box, Modal } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { IconButton } from '@mui/material';
import { useState } from "react";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

export default function DepartureInfo({ hook }){

    const [openPDF, setOpenPDF] = useState(false);
    const [pdf, setPDF] = useState(null);

    const handleClosePDF = () => {
        setOpenPDF(false);
        setPDF(null);
    };

    const displayPDF = (client, date) => {
        if(! client) message.error('No hay Cliente');
        else if(! date) message.error('No hay Fecha');
        else {
            pdfDepartureListByClientDateEvent(client, date)
            .then(data => {
                setPDF(data.data.bytes);
                setOpenPDF(true);     
            })
            .catch(err => {
                message.error(err.message);
            });
        }    
    }

    return(
        <Row>
            <Col lg={24} xs={24}>
                {
                    hook.data.map((og, key) => {
                        return(
                            <Accordion key={`departure_date_${key}`}>
                                <AccordionSummary
                                style={{ backgroundColor: '#ddd' }}
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${key + 1}-content`}
                                id={`panel${key + 1}-header`}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <div style={{ display: 'flex', flexDirection: 'row', height: '100%', alignItems: 'center', marginRight: '20px' }}><strong>{og.date_delivery}</strong></div>
                                        <IconButton
                                            color='primary'
                                            aria-label='pdf'
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                displayPDF(og.client_uuid, og.date_delivery);
                                            }}
                                        >
                                            <PictureAsPdfIcon />
                                        </IconButton>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <TableGroupDepartures 
                                        detailsGroup={og.detailsGroup}
                                    />
                                </AccordionDetails>
                            </Accordion>
                        )
                    })
                }
                <Modal
                    open={openPDF}
                    onClose={handleClosePDF}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Row>
                        {
                        !pdf ? <>Cargando...</> :
                        <Col xs={24} lg={24}>
                            <object width="100%" height="600px" 
                            data={`data:application/pdf;base64,${pdf}`} 
                            type="application/pdf" className="internal"
                            >
                            <embed 
                                src={`data:application/pdf;base64,${pdf}`}
                                type="application/pdf"
                            />
                            </object>
                        </Col>
                        }
                        </Row>
                    </Box>
                </Modal>   
            </Col>
        </Row>
    );
}